export default "__VITE_ASSET__DPYnehet__"